/** @format */

/**
 *



 issuedStatusName

 是

 String

 下发状态


 */

export default function() {
  return [
    // {
    //   title: '序号',
    //   width: 70,
    //   customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`,
    // },
    {
      title: '车场名称',
      dataIndex: 'parkName',
      width: 190,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '车牌号',
      dataIndex: 'plate',
      width: 160,
      scopedSlots: { customRender: 'plate' }
    },
    {
      title: '通道类型',
      dataIndex: 'channelType',
      width: 140,
      scopedSlots: { customRender: 'channelType' }
    },
    {
      title: '通道名称',
      dataIndex: 'enterChannelName',
      width: 240,
      scopedSlots: { customRender: 'text-ellipse-22' }
    },
    {
      title: '修正位数',
      dataIndex: 'revisePlateNum',
      width: 120,
      sortable: true,
      customRender: (text: any) => String(text || '0')
    },
    {
      title: '修正前车牌',
      dataIndex: 'beforePlate',
      width: 140
    },
    {
      title: '修正后车牌',
      dataIndex: 'afterPlate',
      width: 140
      // scopedSlots: { customRender: 'afterPlate' }
    },
    {
      title: '修正前车型',
      dataIndex: 'beforeCarType',
      width: 130,
      customRender: (text: any, record: any, index: number) =>
        this.getLabelByPropFromModel('beforeCarType', record, '- 小型车 大型车'.split(' '))
    },
    {
      title: '修正后车型',
      dataIndex: 'afterCarType',
      width: 130,
      customRender: (text: any, record: any, index: number) =>
        this.getLabelByPropFromModel('afterCarType', record, '- 小型车 大型车'.split(' '))
    },
    {
      title: '修正时间',
      dataIndex: 'reviseTime',
      width: 220,
      sortable: true
    },
    {
      title: '同步状态',
      dataIndex: 'issuedStatusName',
      width: 100,
      scopedSlots: { customRender: 'issuedStatus' }
    },
    {
      title: '操作来源',
      dataIndex: 'reviseFrom',
      width: 120,
      scopedSlots: { customRender: 'reviseFrom' }
      //scopedSlots: { customRender: 'issuedStatus' },
    },
    {
      title: '操作人',
      dataIndex: 'operater',
      width: 130,
      scopedSlots: { customRender: 'text-ellipse-10' }
    },
    {
      title: '停车订单号',
      dataIndex: 'orderId',
      width: 190,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '审核状态',
      dataIndex: 'reviewStatusName',
      width: 100,
      scopedSlots: { customRender: 'status' }
    },
    {
      title: '审核人',
      dataIndex: 'reviewer',
      width: 130,
      scopedSlots: { customRender: 'text-ellipse-10' }
    },
    {
      title: '审核时间',
      dataIndex: 'reviewTime',
      width: 180
    },
    {
      title: '审核意见',
      dataIndex: 'reviewDescription',
      width: 160,
      scopedSlots: { customRender: 'text-ellipse-10' }
    },
    {
      title: '修正图片',
      dataIndex: 'img',
      width: 100,
      scopedSlots: { customRender: 'viewImg' }
    }
  ];
}
